const autoNgTemplateLoaderTemplate1 = require('./networkRowContent.html');

import { ResourceControlOwnership as RCO } from '@/react/portainer/access-control/types';

angular.module('portainer.docker').directive('networkRowContent', [
  function networkRowContent() {
    var directive = {
      templateUrl: autoNgTemplateLoaderTemplate1,
      restrict: 'A',
      transclude: true,
      scope: {
        item: '<',
        parentCtrl: '<',
        allowCheckbox: '<',
        allowExpand: '<',
      },
      controller: ($scope) => {
        $scope.RCO = RCO;
      },
    };
    return directive;
  },
]);
